import Container from '@mui/material/Container';

import { paths } from 'src/routes/paths';

import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';

import PackagingReturnNewEditForm from '../packaging-return-new-edit-form';

export default function PackagingReturnCreateView() {
  const settings = useSettingsContext();

  return (
    <Container maxWidth={settings.themeStretch ? false : 'lg'}>
      <CustomBreadcrumbs
        heading="Create a new return"
        links={[
          {
            name: 'Return',
            href: paths.dashboard.packagingReturn.root,
          },
          { name: 'Create a new return' },
        ]}
        sx={{
          mb: { xs: 3, md: 5 },
        }}
      />

      <PackagingReturnNewEditForm />
    </Container>
  );
}
